// extracted by mini-css-extract-plugin
export default {"button":"activity_button__YgmIO","form-login":"activity_form-login__o18bb"};